<template>
  <div class="app-breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in breadcrumb"
        :key="index"
        :to="item.path"
      >
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script type="text/ecmascript-6">
import AppBreadcrumb from './AppBreadcrumb.js'
export default AppBreadcrumb
</script>

<style lang="scss">
@import "AppBreadcrumb.scss";
</style>



// WEBPACK FOOTER //
// src/components/appBreadcrumb/AppBreadcrumb.vue